import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const APPOINTMENT_TZ = 'Asia/Bangkok'

/**
 * รวมวันที่ + เวลาจากฟอร์ม (ช่อง type="time") เป็น per_date แบบเวลาโรงพยาบาล
 * ใช้กับ CreateAppointData / UpdateVisitById — รูปแบบ "YYYY-MM-DD HH:mm:ss"
 * @param {string} dateStr YYYY-MM-DD
 * @param {string} timeStr HH:mm หรือ HH:mm:ss
 * @returns {string}
 */
export function formatAppointmentPerDateLocal (dateStr, timeStr) {
  if (!dateStr || timeStr == null || timeStr === '') return ''
  const hm = String(timeStr).trim()
  const timePart = /^\d{2}:\d{2}:\d{2}$/.test(hm)
    ? hm
    : /^\d{2}:\d{2}$/.test(hm)
      ? `${hm}:00`
      : hm
  const d = dayjs.tz(`${dateStr} ${timePart}`, 'YYYY-MM-DD HH:mm:ss', APPOINTMENT_TZ)
  if (!d.isValid()) return `${dateStr} ${timePart}`
  return d.format('YYYY-MM-DD HH:mm:ss')
}

/**
 * แปลง slot_start จาก GET เป็นเวลาโรงพยาบาลแบบไม่มี offset ตามสเปก POST: "2026-04-06T13:00:00"
 * GET appointment/slots มักคืนเวลาโรงพยาบาลจาก SQL แต่ serialize เป็น …Z — ต้อง parse ใน APPOINTMENT_TZ
 * (ให้ตรงกับ formatSlotRange ที่ใช้ dayjs.tz(value, APPOINTMENT_TZ)) ไม่ใช่ convert จาก UTC
 * @param {string|Date|null|undefined} slotStart
 * @returns {string|null}
 */
export function normalizeAppointmentSlotStart (slotStart) {
  if (slotStart == null || slotStart === '') return null
  const raw = String(slotStart).trim()
  if (/[zZ]$/.test(raw)) {
    const d = dayjs.tz(raw, APPOINTMENT_TZ)
    if (!d.isValid()) return null
    return d.format('YYYY-MM-DD[T]HH:mm:ss')
  }
  if (/[+-]\d{2}:?\d{2}$/.test(raw)) {
    const d = dayjs(raw).tz(APPOINTMENT_TZ)
    if (!d.isValid()) return null
    return d.format('YYYY-MM-DD[T]HH:mm:ss')
  }
  const naiveMatch = raw.match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2})?)$/)
  if (naiveMatch) {
    const [, datePart, timePart] = naiveMatch
    const normalized = formatAppointmentPerDateLocal(datePart, timePart)
    return normalized ? normalized.replace(' ', 'T') : null
  }
  const d = dayjs.tz(raw, APPOINTMENT_TZ)
  if (!d.isValid()) return null
  return d.format('YYYY-MM-DD[T]HH:mm:ss')
}
